module.exports = __webpack_public_path__ + "static/media/cellfinate_social_6.72d80e54.jpg";